<template>
  <div class="fixed-top" id="header">
    <b-navbar toggleable="lg" variant="" type="">
      <b-navbar-brand href="#">
        <router-link to="/AssameseMobile">
          <div style="display:flex; align-items:flex-start; gap:8px;">
            <img class="logo" src="../assets/apdcl_logo.png" alt="logo" />
            <div>
              <div id="title-a" class="title-a text-blue">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</div>
              <div id="title-e" class="title-e text-blue">Assam Power Distribution Company Limited</div>
            </div>
          </div>
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" style="border:none; outline:none;">
        <template>
          <div style="border:solid 1px black; border-radius:3px; font-size:2rem;">
            <b-icon icon="list"></b-icon>
          </div>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="box-shadow: 2px 2px 9px 0px;">
        <b-navbar-nav class="ml-auto">
          <b-row>
            <b-col cols="3" offset=1><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AssameseMobile">মূখ্যপৃষ্ঠা</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/ActsAndRules">আইন আৰু নীতি</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AllDocuments">নথিসমূহ</router-link></b-nav-item></b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1>
              <b-nav-item-dropdown class="r-link iphone5font" text="নিবিদা" style="width:15rem !important; z-index:1;" right>
                <b-dropdown-item href="AS_TenderCurrent"><span class="iphone5font dropdownItem">চলিত বিত্তীয় বৰ্ষ</span></b-dropdown-item>
                <b-dropdown-item href="AS_TenderPrevious"><span class="iphone5font dropdownItem">বিগত বিত্তীয় বৰ্ষ</span></b-dropdown-item>
                <b-dropdown-item href="AS_TenderArchive"><span class="iphone5font dropdownItem">আৰ্কাইভ</span></b-dropdown-item>
              </b-nav-item-dropdown>
            </b-col>
            <b-col cols="4">
              <b-nav-item-dropdown class="r-link iphone5font" text="বাতৰি" style="width:15rem !important; z-index:1;" right>
                <b-dropdown-item href="AS_Award"><span class="dropdownItem iphone5font">সন্মান আৰু স্বীকৃতি</span></b-dropdown-item>
                <b-dropdown-item href="AS_Newsletter"><span class="dropdownItem iphone5font">বাৰ্তালোচনী</span></b-dropdown-item>
                <b-dropdown-item href="AS_BijuleeNewsBulletin"><span class="dropdownItem iphone5font">বিজুলী প্ৰচাৰ-পত্ৰিকা</span></b-dropdown-item>
                <b-dropdown-item href="AS_PressRelease"><span class="dropdownItem iphone5font">প্ৰেচ বিজ্ঞপ্তি</span></b-dropdown-item>
                <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank"><span class="dropdownItem iphone5font">টক্-শ্ব'ত এপিদিচিএল</span></b-dropdown-item>
                <b-dropdown-item href="AS_Testimonial"><span class="dropdownItem iphone5font">দস্তাবেজ</span></b-dropdown-item>
                <b-dropdown-item href="AS_Workshop"><span class="dropdownItem">কৰ্মশালা আৰু আলোচনা চক্ৰ</span></b-dropdown-item>
              </b-nav-item-dropdown>
            </b-col>
            <b-col cols="4" style="z-index:1;"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AS_Contact">যোগাযোগ কৰক</router-link></b-nav-item></b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AS_About">আমাৰ বিষয়ে</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AS_Gallery">গেলেৰী</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AS_RTI">তথ্যৰ অধিকাৰ</router-link></b-nav-item></b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AS_Career">নিযুক্তি</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/AS_FAQ">সততে উত্থাপিত প্ৰশ্নসমূহ</router-link></b-nav-item></b-col>
            <b-col cols="4">
              <b-nav-item>
                <div id="login">
                  <b-button v-b-modal.modal-headerMobile size="sm" class="iphone5font" variant="outline-danger" style="margin-top: -5px;">
                    লগ্-ইন
                  </b-button>
                </div>
              </b-nav-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1>
              <b-nav-item href="#">
                <router-link class="r-link iphone5font customSpan" to="/">English</router-link>
              </b-nav-item>
            </b-col>
          </b-row>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-modal no-close-on-esc no-close-on-backdrop class="modal fade" id="modal-headerMobile" hide-footer title="আপোনাৰ একাউণ্টত লগ ইন কৰক">
      <div>
        <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm"
          style="z-index:10000;position:absolute" variant="dark" id="loader">
          <br>
          <div id="userDiv" class="showDiv">
            <label>ম'বাইল নম্বৰ প্ৰবিষ্ট কৰক</label>
            <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
              <b-input-group-prepend is-text>
                <b-icon icon="phone"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="number" id="mobileNoMb" autocomplete="off" placeholder="ম'বাইল নম্বৰ"></b-form-input>
            </b-input-group>
            <span style="display:none;color:red;text-align:center;" id="errorMsg"></span>
            <div id="sendOtpBtn" class="showDiv">
              <b-row>
                <b-col cols="12">
                  <router-link to="">
                    <b-button block @click="sendOtp()" variant="primary">OTP প্ৰেৰণ কৰক</b-button>
                  </router-link>
                </b-col>
              </b-row>
            </div>
            <div id="otpDiv" class="hideDiv">
              <label>OTP প্ৰবিষ্ট কৰক</label>
              <b-input-group class="mb-2" style="width:100%;">
                <b-input-group-prepend is-text>
                  <b-icon icon="check2-circle"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="text" id="otp" autocomplete="off" placeholder="OTP প্ৰবিষ্ট কৰক"></b-form-input>
              </b-input-group>
              <span style="color:red;padding-left:40%" id="otpInvalid"></span>
              <b-row>
                <b-col cols="12">
                  <b-button block @click="loginUser()" variant="primary">লগ ইন</b-button>
                  <b-button block @click="resendOtp()" variant="outline-primary">OTP পুনৰ প্ৰেৰণ কৰক</b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col cols="12" style="text-align:center">
                <span>একাউণ্ট নাই নেকি?<br>
                  <router-link to="/AS_ConsumerRegistration">পঞ্জীয়ন কৰক</router-link>
                </span>
              </b-col>
            </b-row>
          </div>
          <br>
        </b-overlay>
      </div>
    </b-modal>
  </div>
</template>

<script scoped="true">

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var user = 0;

export default{
  computed:{
   userIdState() {
      return this.user_id.length == 12 ? true : false
      //this.login()
    }
  },
  data() {
      return {
        selected: 'consumer',
        user_id: '',
        show: false,
        mobileNo:"",
        urlCommon : this.$urlCommon+"/api/postOtp",
      }
    },

  methods:{
    scrollFunction(event) {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById("header").style.backgroundColor = "#eeeeee";

      } else {
        document.getElementById("header").style.backgroundColor = "";
       
      }
    },
    
    sendOtp()
    {

     
      var mobile = document.getElementById("mobileNoMb").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent=this;
      this.show=true;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src" : "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };


      axios.request(config)
      .then((response) => {
        console.log(response.data);
        parent.show=false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            document.getElementById("mobileNoMb").readOnly =true;
            document.getElementById("otpDiv").classList.add("showDiv");
            document.getElementById("sendOtpBtn").classList.remove("showDiv");
            document.getElementById("sendOtpBtn").classList.add("hideDiv");
          }
      })
      .catch((error) => {
        console.log(error);
      });

    },
    loginUser()
    {

     
      var mobile = document.getElementById("mobileNoMb").value;
      var otpNo = document.getElementById("otp").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent=this;
      this.show=true;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
        "src":"portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/otp/verify',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };


      axios.request(config)
      .then((response) => {
        console.log(response.data);
        parent.show=false;
        if (response.data.status == "success") {
          
          var accessToken=response.data.accessToken;
          sessionStorage.setItem("accessToken", response.data.accessToken);
          sessionStorage.setItem("consList", JSON.stringify(response.data.consList));
         console.log(response.data.consList[0]);

     var consNo = response.data.consList[0];
     
     var consType;
         
     let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo":mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: parent.$urlCommon+'/api/web/auth/getConsDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
    
      axios.request(config)
      .then((response) => {
        parent.show=false;
        console.log(response.data);
        if(response.data.message=="00")
          {
          sessionStorage.setItem("selectedCons", consNo);
          consType = response.data.connType;
          if(consType == "POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardPostpaid";
                return false;
        
              }
          else if( consType == "SMART POSTPAID")
             {
                  window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                  return false;
              }
          else  if(consType == "PREPAID")
              {
                window.location.href = "/website/ConsumerDashboardPrepaid";
                return false;
               
              }
          else  if(consType == "SMART PREPAID")
              {
                window.location.href="/website/ConsumerDashboardSmartPrepaid";
                return false;
               
              }
          }
        else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }
      })
      .catch((e) => {
        parent.show=false;
        console.log("Caught :::::::::::::::", e.message);
        if(e.message=="Network Error")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }
      });
   

          }
          else
          {
            parent.$bvToast.toast('OTP Invalid !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
          }
      })
      .catch((error) => {
        console.log(error);
      });

    },
    resendOtp()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNoMb").value;



      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "old",
        "src": "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      parent.show= true;
      axios.request(config)
      .then((response) => {
      
        parent.show= false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

 
  },
  mounted(){
  //   var url_string = window.location.href;
  //   var url = new URL(url_string);
  //   var mobile = url.searchParams.get("mobileNo");
  //   console.log("mobile:::::"+mobile)
  //   if(mobile>0)
  //   {
  //     this.$bvModal.show("modal-loginMb");
  //     this.mobileNo=mobile;
  //     }
   }
}

</script>

<style lang="scss" scoped="true">
.customSpan {
  background-color: #fff78d;
  padding: 4px 10px 4px 10px;
  font-weight: 500;
  border-radius: 2px;
}

#header {
  transition: 0.6s;
}

.marginLeft {
  margin-left: 30px;
}

.title-a {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
}

.title-e {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.tagline-a,
.tagline-e,
.language,
.support {
  display: none !important;
}

:deep(.navbar) {
  flex-wrap: nowrap !important;
}

:deep(.navbar-collapse) {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
}

.navbar-brand {
  margin-left: -10px !important;
  padding: 0 !important;
}

.text-orange { color: #ff5722; }
.text-blue { color: #01579b; }
.border { border: 1px solid; }

#header, #title-e, #title-a {
  transition: 0.5s;
}

.logo {
  height: 45px;
  width: 45px;
  min-width: 45px;
  object-fit: contain;
  flex-shrink: 0;
}

.nav-bgcolor {
  background-color: white;
}

.hideDiv {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  padding: 0rem;
}

.showDiv {
  visibility: visible;
  opacity: 1;
}

/* iPhone 5 */
@media only screen and (min-device-width: 320px) and (max-device-height: 568px) 
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .title-a { font-size: 10px; font-weight: 900; }
  .title-e { font-size: 10px; font-weight: 700; }
  .navbar-toggler { padding: 0px !important; }
  .navbar-brand { margin-right: 0px !important; }
  .iphone5font { font-size: 12px; }
  .logo { height: 28px; width: 28px; }
}

/* General mobile up to 480px (covers iPhone 15 Pro etc.) */
@media only screen and (max-width: 480px) {
  .title-a {
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 0px;
    white-space: normal;
    overflow: visible;
    line-height: 1.2;
  }
  .title-e {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0px;
    white-space: normal;
    overflow: visible;
    line-height: 1.2;
  }
  .logo {
    height: 38px;
    width: 38px;
    min-width: 38px;
  }
  .navbar-brand {
    max-width: calc(100% - 55px) !important;
    flex-shrink: 1;
    overflow: hidden;
  }
}

/* iPhone 6/7/8 */
@media only screen and (min-device-width: 375px) and (max-device-height: 667px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .title-a { font-size: 12px; font-weight: 900; }
  .title-e { font-size: 12px; font-weight: 700; }
  .navbar-toggler { padding: 0px !important; }
  .navbar-brand { margin-right: 10px !important; }
}

@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}

div {
  font-family: arial, Assamese_Font;
}
</style>
